/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Log_Out_Nav_ItemInputs */

const en_log_out_nav_item = /** @type {(inputs: Log_Out_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log out`)
};

const id_log_out_nav_item = /** @type {(inputs: Log_Out_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keluar`)
};

const ms_log_out_nav_item = /** @type {(inputs: Log_Out_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log keluar`)
};

const ca_log_out_nav_item = /** @type {(inputs: Log_Out_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanca la sessió`)
};

const cs_log_out_nav_item = /** @type {(inputs: Log_Out_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log out`)
};

const da_log_out_nav_item = /** @type {(inputs: Log_Out_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log ud`)
};

const de_log_out_nav_item = /** @type {(inputs: Log_Out_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausloggen`)
};

const et_log_out_nav_item = /** @type {(inputs: Log_Out_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logi välja`)
};

const es_log_out_nav_item = /** @type {(inputs: Log_Out_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar sesión`)
};

const fr_log_out_nav_item = /** @type {(inputs: Log_Out_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se déconnecter`)
};

const hr_log_out_nav_item = /** @type {(inputs: Log_Out_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odjava`)
};

const it_log_out_nav_item = /** @type {(inputs: Log_Out_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disconnetti`)
};

const lv_log_out_nav_item = /** @type {(inputs: Log_Out_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Izrakstīties`)
};

const lt_log_out_nav_item = /** @type {(inputs: Log_Out_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atsijungti`)
};

const hu_log_out_nav_item = /** @type {(inputs: Log_Out_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kilépés`)
};

const nl_log_out_nav_item = /** @type {(inputs: Log_Out_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log out`)
};

const nb_log_out_nav_item = /** @type {(inputs: Log_Out_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logg ut `)
};

const pl_log_out_nav_item = /** @type {(inputs: Log_Out_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyloguj się`)
};

const pt_log_out_nav_item = /** @type {(inputs: Log_Out_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sair`)
};

const ro_log_out_nav_item = /** @type {(inputs: Log_Out_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deconectați-vă`)
};

const sk_log_out_nav_item = /** @type {(inputs: Log_Out_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odhlásit`)
};

const sl_log_out_nav_item = /** @type {(inputs: Log_Out_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odjava`)
};

const fi_log_out_nav_item = /** @type {(inputs: Log_Out_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirjaudu ulos`)
};

const sv_log_out_nav_item = /** @type {(inputs: Log_Out_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logga ut`)
};

const vi_log_out_nav_item = /** @type {(inputs: Log_Out_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thoát`)
};

const tr_log_out_nav_item = /** @type {(inputs: Log_Out_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çıkış`)
};

const el_log_out_nav_item = /** @type {(inputs: Log_Out_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Αποσύνδεση`)
};

const bg_log_out_nav_item = /** @type {(inputs: Log_Out_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Излизане`)
};

const ru_log_out_nav_item = /** @type {(inputs: Log_Out_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log out`)
};

const sr_log_out_nav_item = /** @type {(inputs: Log_Out_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Одјави се`)
};

const uk_log_out_nav_item = /** @type {(inputs: Log_Out_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вийти`)
};

const ka_log_out_nav_item = /** @type {(inputs: Log_Out_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`გამოსვლა`)
};

const hi_log_out_nav_item = /** @type {(inputs: Log_Out_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लॉग आउट`)
};

const th_log_out_nav_item = /** @type {(inputs: Log_Out_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ออกจากระบบ`)
};

const ko_log_out_nav_item = /** @type {(inputs: Log_Out_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로그아웃`)
};

const zh_log_out_nav_item = /** @type {(inputs: Log_Out_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登出`)
};

const zh_tw_log_out_nav_item = /** @type {(inputs: Log_Out_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登出`)
};

const ja_log_out_nav_item = /** @type {(inputs: Log_Out_Nav_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ログアウト`)
};

/**
* | output |
* | --- |
* | "Log out" |
*
* @param {Log_Out_Nav_ItemInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const log_out_nav_item = /** @type {((inputs?: Log_Out_Nav_ItemInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Log_Out_Nav_ItemInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_log_out_nav_item(inputs)
	if (locale === "ms") return ms_log_out_nav_item(inputs)
	if (locale === "ca") return ca_log_out_nav_item(inputs)
	if (locale === "cs") return cs_log_out_nav_item(inputs)
	if (locale === "da") return da_log_out_nav_item(inputs)
	if (locale === "de") return de_log_out_nav_item(inputs)
	if (locale === "et") return et_log_out_nav_item(inputs)
	if (locale === "es") return es_log_out_nav_item(inputs)
	if (locale === "fr") return fr_log_out_nav_item(inputs)
	if (locale === "hr") return hr_log_out_nav_item(inputs)
	if (locale === "it") return it_log_out_nav_item(inputs)
	if (locale === "lv") return lv_log_out_nav_item(inputs)
	if (locale === "lt") return lt_log_out_nav_item(inputs)
	if (locale === "hu") return hu_log_out_nav_item(inputs)
	if (locale === "nl") return nl_log_out_nav_item(inputs)
	if (locale === "nb") return nb_log_out_nav_item(inputs)
	if (locale === "pl") return pl_log_out_nav_item(inputs)
	if (locale === "pt") return pt_log_out_nav_item(inputs)
	if (locale === "ro") return ro_log_out_nav_item(inputs)
	if (locale === "sk") return sk_log_out_nav_item(inputs)
	if (locale === "sl") return sl_log_out_nav_item(inputs)
	if (locale === "fi") return fi_log_out_nav_item(inputs)
	if (locale === "sv") return sv_log_out_nav_item(inputs)
	if (locale === "vi") return vi_log_out_nav_item(inputs)
	if (locale === "tr") return tr_log_out_nav_item(inputs)
	if (locale === "el") return el_log_out_nav_item(inputs)
	if (locale === "bg") return bg_log_out_nav_item(inputs)
	if (locale === "ru") return ru_log_out_nav_item(inputs)
	if (locale === "sr") return sr_log_out_nav_item(inputs)
	if (locale === "uk") return uk_log_out_nav_item(inputs)
	if (locale === "ka") return ka_log_out_nav_item(inputs)
	if (locale === "hi") return hi_log_out_nav_item(inputs)
	if (locale === "th") return th_log_out_nav_item(inputs)
	if (locale === "ko") return ko_log_out_nav_item(inputs)
	if (locale === "zh") return zh_log_out_nav_item(inputs)
	if (locale === "zh-tw") return zh_tw_log_out_nav_item(inputs)
	if (locale === "ja") return ja_log_out_nav_item(inputs)
	return en_log_out_nav_item(inputs)
});